import React, {useState, useEffect, useRef, useContext} from "react";
import {ToastNotification, ProgressLoader, TableCustomer} from "components/shared";
import {UsersService} from "services/http";
import Init from './init'
import './admin.css';
import {Dropdown} from "primereact/dropdown";
import {Column} from "primereact/column";
import {Calendar} from "primereact/calendar";
import {InputText} from "primereact/inputtext";
import {ProgressBar} from "primereact/progressbar";
import {confirmDialog} from "primereact/confirmdialog";
import {Popup} from "components/shared/popup/popup";
import {User} from "./user";
import {Register} from "./register";
import {SocketContext} from "services";


export const Users = (props) => {
    const [loading, setLoading] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const [visible, setVisible] = useState(false)
    const [visibleAdd, setVisibleAdd] = useState(false)
    const [user, setUser] = useState()
    const [data, setData] = useState([])
    const [payload, setPayload] = useState();
    const [status, setStatus] = useState();
    const [dataFilter, setDataFilter] = useState(Init.dataFilter)
    const childRef = useRef();
    const dt = useRef(null);
    const socketContext = useContext(SocketContext);
    const [callback, setCallback] = useState();
    let usersSubscription;

    useEffect(() => {
        _getData();
        _getStatus();
        //UNSEBSCRIBE INTERVENTION TOPIC
        return () => {
            usersSubscription && usersSubscription.unsubscribe()
        }
    }, []);

    useEffect(() => {
        if (data.length !== 0 && payload) {
            let dataM = Init.updateDataCallback(data, payload?.content, showUser, confirmDelete);
            dt.current?.updateData(dataM)
        }
    }, [data, payload]);

    useEffect(() => {
        //SUBSCRIBE TO THE INTERVENTION TOPIC
        async function promise() {
            return await socketContext.getStompClient();
        }

        promise().then((result) => {
            usersSubscription = result.subscribe(`${process.env.REACT_APP_SOCKET_USER_TOPIC}`, callbackRecieve);
        });
    }, []);

    //ON RECIEVE CALLBACK BROADCAST
    const callbackRecieve = (dataRecieve) => {
        setPayload(JSON.parse(dataRecieve.body));
    }

    function _getData() {
        setLoading(true);
        UsersService.getUsers().then(data => {
            setData(_mapData(data.result));
            setLoading(false);
        }, error => {
            childRef?.current?.showToast({type: "warn", title: "Error response", message: error, durable: true});
            setLoading(false);
        });
    }

    function _getStatus() {
        setLoadingStatus(true);
        UsersService.getStatus().then(data => {
            var status_add = [{statusUserId: null, description: 'All status'}];
            var status_horsLigne = [{statusUserId: 6, description: 'Hors ligne'}]
            status_add.push.apply(status_add, data.result);
            status_add.push.apply(status_add, status_horsLigne);
            setStatus(status_add);
            setLoadingStatus(false)
        }, error => {
            childRef?.current?.showToast({type: "warn", title: "Error response", message: error, durable: true});
            setLoadingStatus(false);
        })

    }

    function _delete(data) {
        UsersService.submitUserDelete(data).then(data => {
            childRef?.current?.showToast({
                type: "success",
                title: "Success response",
                message: data.message,
                durable: false
            });
            dt.current?.loadingData();
        }, error => {
            childRef?.current?.showToast({
                type: "warn",
                title: "Error response",
                message: error, durable: false
            });
        });

    }

    function updateData() {
        childRef?.current?.showToast({
            type: "success",
            title: "Success response",
            message: 'Success',
            durable: false
        });
        hideUser();
        UsersService.getUsers().then(dataResult => {
            setData(_mapData(dataResult.result))
            setDataFilter(Init.dataFilter)
            dt.current.loadingData();
        }, error => {
            childRef?.current?.showToast({type: "warn", title: "Error response", message: error, durable: true});
        })
    }


    function _refresh() {
        UsersService.getUsers().then(dataResult => {
            setData(_mapData(dataResult.result))
            setDataFilter(Init.dataFilter)
            dt.current.onRefresh()
        }, error => {
            childRef?.current?.showToast({type: "warn", title: "Error response", message: error, durable: true});
        })
    }


    function _mapData(users) {
        var list = []
        users?.map((user, index) => {
                list.push(Init.mapUserData(user, showUser, confirmDelete, index))
            }
        )
        return list;
    }


    const confirmDelete = (user) => {
        var char = user?.enabled === 1 ? 'disable' : 'enable'
        confirmDialog({
            message: 'Are you sure that you want to ' + char + ' ' + user?.username + ' ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                _delete(user)
            },
            reject: () => () => {
            },
            onHide: () => {

            }
        });
    }
    const showUser = (user) => {
        setUser(user)
        setVisible(true)
    }
    const hideUser = () => {
        setUser(null)
        setVisible(false)
        setVisibleAdd(false)
        //  dt.current?.loadingData();
    }
    const _add = () => {
        setVisibleAdd(true)
    }
    const _filter = (event, type) => {
        if (event.target.name === 'enabled') {
            event.target.value = event.target.value !== null ? Number(event.target.value) : null;
        }
        if (event.target.value === 'All status') {
            dt.current?.onFilter(null, event.target.name, type);
        } else {
            dt.current?.onFilter(event.target.value, event.target.name, type);
        }

        setDataFilter(prevState => {
            return {...prevState, [event.target.name]: event.target.value}
        });
    }
    const _filterDate = (event) => {
        setDataFilter(prevState => {
            return {...prevState, [event.target.id]: event.target.value}
        });
    }

    useEffect(() => {
        dt.current?.onFilter(dataFilter?.enabled, 'enabled', 'equals');
    });

    useEffect(() => {
        dt.current?.onFilterDate(dataFilter.expiryDateMin, dataFilter.expiryDateMax, 'expiryDate');
    }, [dataFilter?.expiryDateMin, dataFilter?.expiryDateMax]);

    const statusItemTemplate = (option) => {
        var dataShow = option?.description?.replace("_", " ")
        var id = option?.statusUserId
        return (
            <>
                <span className={`customer-badge  `}>
                      <i className={`${Init.getIconstatus(id)} status-${id} `}></i>{' ' + dataShow}</span>
            </>);
    }

    const nameBodyTemplate = (rowData) => {
        return <span className={`customer-badge`}>{rowData.name}</span>;
    }
    const enableBodyTemplate = (rowData) => {
        var enabled = rowData.enabled === 1 ? 'enabled' : 'disabled';
        return <span className={`customer-badge  status-${enabled}`}>{enabled}</span>;
    }

    const displayValueTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData}<b>%</b>
            </React.Fragment>
        );
    }
    const capacityBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div style={{width: '100%', textAlign: 'right'}}>
                <span className={`badge-count-c`}>{rowData.capacityCurrent}</span>
                <ProgressBar className={`ptogress-bar-${rowData.masseProg}`}
                             value={rowData.capacity} showValue={true}
                             displayValueTemplate={displayValueTemplate}
                />
                </div>
            </React.Fragment>
        );
    }
    const statusBodyTemplate = (rowData) => {
        var dataShow = rowData?.statusUserId?.replace("_", " ")
        var id = rowData?.statusId
        return (
            <React.Fragment>
                <>
                <span className={`customer-badge`}>
                      <i className={`${Init.getIconstatus(id)} status-${id} `}></i>{' ' + dataShow}</span>
                </>

            </React.Fragment>
        );
    }
    const enabledItemTemplate = (option) => {
        return (
            <React.Fragment>
                <span className={`customer-badge status-${option.code}`}>{option.description}</span>
            </React.Fragment>
        );
    }
    const dateBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className={`customer-badge`}>{rowData.expiryDate}</span>
            </React.Fragment>
        );
    }

    const elementFilter = (param) => {
        switch (param) {
            case 'statusUserId':
                return <Dropdown style={{width: '100%', textAlign: 'left'}}
                                 className="p-column-filter select-item"
                                 value={dataFilter?.statusUserId}
                                 options={status}
                                 optionLabel='description'
                                 optionValue='description'
                                 name='statusUserId'
                                 itemTemplate={statusItemTemplate}
                                 valueTemplate={statusItemTemplate}
                                 onChange={(e) => _filter(e, 'equals')}/>;
            case 'expiryDate':
                return <div>
                    {/*<Calendar id="expiryDateMin"*/}
                    {/*          name='expiryDate'*/}
                    {/*          onChange={(e) => _filterDate(e)}*/}
                    {/*          className="p-column-filter-date"*/}
                    {/*          placeholder="From"*/}
                    {/*          dateFormat="yy/mm/dd"*/}
                    {/*          monthNavigator*/}
                    {/*          yearNavigator*/}
                    {/*          yearRange="2020:2100"*/}
                    {/*          touchUI*/}
                    {/*          showButtonBar*/}
                    {/*          value={dataFilter?.expiryDateMin}/>*/}

                    <Calendar id="expiryDateMax"
                              name='expiryDate'
                              onChange={(e) => _filterDate(e)}
                              className="p-column-filter"
                              placeholder="To"
                              dateFormat="yy/mm/dd"
                              monthNavigator
                              yearNavigator
                              yearRange="2020:2100"
                              touchUI
                              showButtonBar
                              value={dataFilter?.expiryDateMax}/>
                </div>;
            case 'enabled':
                return <Dropdown style={{width: '100%'}}
                                 className="p-column-filter select-item"
                                 value={dataFilter?.enabled}
                                 options={[
                                     {"description": 'ALL', "value": null, "code": "All"},
                                     {"description": 'ENABLED', "value": 1, "code": "enabled"},
                                     {"description": 'DISABLED', "value": 0, "code": "disabled"}
                                 ]}
                                 name='enabled'
                                 itemTemplate={enabledItemTemplate}
                                 optionLabel='description'
                                 onChange={(e) => _filter(e, 'equals')}/>;
            case 'capacity':
                return <InputText
                    style={{width: '100%'}}
                    className="p-column-filter"
                    placeholder="Current"
                    autocomplete='off'
                    autocapitalize='off'
                    name={param}
                    value={dataFilter[param]}
                    onChange={(e) => _filter(e, 'startsWith')}/>
            default:
                return <InputText
                    style={{width: '100%'}}
                    className="p-column-filter"
                    autocomplete='off'
                    autocapitalize='off'
                    name={param}
                    value={dataFilter[param]}
                    onChange={(e) => _filter(e, param === 'name' ? 'contains' : 'startsWith')}/>
        }
    }

    const columns = Init.getColumns().map((col, i) => {
        return <Column key={col.field}
                       field={col.field}
                       header={col.header}
                       sortable={col.header !== 'Action'}
                       className={`p-columns ${col.header === 'Name' ? 'p-columns-name' : col.header === 'Status' ? 'p-columns-status' : col.header === 'Username' ? 'p-columns-username' : ''}`}
                       filterElement={elementFilter(col.field)}
                       body={col.header === 'Name' ? nameBodyTemplate :
                           col.header === 'Status' ? statusBodyTemplate :
                               (col.header === 'ExpiryDate' ? dateBodyTemplate :
                                   (col.header === 'Capacity' ? capacityBodyTemplate :
                                       (col.header === 'Enabled' ? enableBodyTemplate : '')))}
                       filterMatchMode={col.header === 'CapacityNormal' ? 'gte' : ''}
                       filter={col.header !== 'Action'}
        />;
    });


    return (
        <div className="scroll-container" style={{height: "90vh", position: "relative"}}>
            {loading || loadingStatus ? <ProgressLoader/> :
                <>
                    <TableCustomer
                        title="Agents"
                        icon='pi bi bi-person-lines-fill'
                        data={data}
                        ref={dt}
                        columns={columns}
                        refresh={_refresh}
                        className="table-large"
                        search
                        add={_add}
                    />
                    <Popup
                        header={`${user?.lastName} ${user?.firstName}`}
                        visible={visible}
                        maximizable
                        style={{width: "60rem"}}
                        onHide={hideUser}>
                        <User user={user} refresh={updateData}/>
                    </Popup>
                    <Popup
                        header={"New "}
                        visible={visibleAdd}
                        maximizable
                        style={{width: "60rem"}}
                        onHide={hideUser}>
                        <Register refresh={updateData}/>
                    </Popup>
                </>
            }
            <ToastNotification ref={childRef}/>
        </div>
    )
}